import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetIncidentsInputDto, IncidentCreateDto, IncidentDto, IncidentExcelDownloadDto, IncidentUpdateDto } from '../dtos/incident/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class IncidentService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: IncidentCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentDto>({
      method: 'POST',
      url: '/api/operational/incidents',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/incidents/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/incidents',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentDto>({
      method: 'GET',
      url: `/api/operational/incidents/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/incidents/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetIncidentsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IncidentDto>>({
      method: 'GET',
      url: '/api/operational/incidents',
      params: { incidentTypeId: input.incidentTypeId, incidentCauseId: input.incidentCauseId, incidentDate: input.incidentDate, incidentDateFrom: input.incidentDateFrom, incidentDateTo: input.incidentDateTo, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, intensityDegreeId: input.intensityDegreeId, incidentOriginId: input.incidentOriginId, incidentDetectionId: input.incidentDetectionId, userId: input.userId, notes: input.notes, oldIncidentReference: input.oldIncidentReference, oldIncidentReferenceFrom: input.oldIncidentReferenceFrom, oldIncidentReferenceTo: input.oldIncidentReferenceTo, number: input.number, numberFrom: input.numberFrom, numberTo: input.numberTo, authorizationUserId: input.authorizationUserId, isAuthorized: input.isAuthorized, mainDiagnosisId: input.mainDiagnosisId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: IncidentExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/incidents/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, incidentTypeId: input.incidentTypeId, incidentCauseId: input.incidentCauseId, incidentDate: input.incidentDate, incidentDateFrom: input.incidentDateFrom, incidentDateTo: input.incidentDateTo, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, intensityDegreeId: input.intensityDegreeId, incidentOriginId: input.incidentOriginId, incidentDetectionId: input.incidentDetectionId, userId: input.userId, notes: input.notes, oldIncidentReference: input.oldIncidentReference, oldIncidentReferenceFrom: input.oldIncidentReferenceFrom, oldIncidentReferenceTo: input.oldIncidentReferenceTo, number: input.number, numberFrom: input.numberFrom, numberTo: input.numberTo, authorizationUserId: input.authorizationUserId, isAuthorized: input.isAuthorized, mainDiagnosisId: input.mainDiagnosisId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentDto[]>({
      method: 'GET',
      url: '/api/operational/incidents/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: IncidentUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IncidentDto>({
      method: 'PUT',
      url: `/api/operational/incidents/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}